import React from 'react';
import ServiceTabs from './Tabs';

function Services() {
    return <ServiceTabs />;
}

export default React.memo(Services);
